import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SfSiteInfo, SITE_INFO } from '@app/sf-lib/public_api';

@Injectable({
  providedIn: 'root',
})

export class GenericResolver  {
  private siteInfo = inject<SfSiteInfo>(SITE_INFO);

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
    if (!state.url) {
      return null;
    }

    const fragSegments: string[] = state.url.split('#');
    const querySegments: string[] = (fragSegments[0] || '').split('?');
    let segments: string[];
    if (this.siteInfo.lang.default === true) {
      segments = (querySegments[0] || '').split('/');
    } else {
      // for no default lang ie: /nl/generic remove the parameter language of the segment.
      segments = (querySegments[0] || '').split('/').slice(2);
    }
    segments = segments.filter(str => str.length > 0);
    if (segments.length <= 0) {
      return null
    }
    const genericName: string = segments.join('-');
    return genericName
  }
}
